import React, { FC } from "react";

export const FullScreenVideoPlayerIcon: FC<any> = () => {
    return (
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1 0H4V1H1V4L0 4V1V0H1ZM0 10V13V14H1H4V13H1V10H0ZM15 10V13H12V14H15H16V13V10H15ZM16 4V1V0H15H12V1H15V4L16 4Z" />
        </svg>
    );
}
